import './grid_lines.less';

import React from 'react';

import range from 'lodash/range';
import map from 'lodash/map';

const GridLines = ({
  internalGridWidth,
  columnCount,
  tilePadding,
  tileMargin,
  height
}) => {
  const tileLength = internalGridWidth / (1.0 * columnCount);
  const gridWidth = parseInt(tileLength)*columnCount;

  return (
    <div className="grid-lines" style={{width: gridWidth}}>
      { map(range(columnCount), (i) => 
        <div className="grid-line-wrapper" style={{
          width: Math.round(tileLength),
          height,
          transform: `translateX(${Math.round(i*tileLength)}px)`
        }}>
          <div className="grid-line" style={{
            margin: `${tileMargin}`,
            padding: `${tilePadding}`,
          }}>
            <div className="grid-line-fill" />
          </div>
        </div>
      )}
    </div>
  );
};

export default GridLines;
